import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CONSTANTS from "../../../misc/constants";
import Text from "../../utils/Text";
import Select from "../../utils/Select";
import RichTextEditor from "../../utils/RichTextEditor";
import styled from "styled-components";
import Check from "../../utils/Check";
import axios from "axios";

import { toast } from 'react-toastify';

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [otherContactType, setOtherContactType] = useState("");
  const [otherContactValue, setOtherContactValue] = useState("");
  const [otherContactPlaceholder, setOtherContactPlaceholder] = useState("");
  const [subject, setSubject] = useState("");
  const [bug, setBug] = useState(false);
  const [content, setContent] = useState("");

  const langCode = useSelector((store) => store.options.lang.code);



  useEffect(() => {
    document.title = `${CONSTANTS.APP_NAME} | Contact`;
  }, []);
  /**Set the title based on actual action edit or create -->*/

  const lang = useSelector((store) => store.options.lang);

  return (
    <StyledContact>
      <>
        <h1>{lang.data.contact.title}</h1>
        <a href="https://t.me/Xaek5" target="blank"><button> Telegram</button></a>
        <br/>
        <span>*Contact form in maintenance</span>
      </>
    </StyledContact>
  );
};

const StyledContact = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  width: 100%;
  span{
      color: lightgray;
  }
  form {
    width: 80%;
  }
`;

export default Contact;
